module.exports = __webpack_public_path__ + "static/img/3-3.693dfe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-3.png
// module id = LNXU
// module chunks = 1